@if (showCuratedMentions) {
    <div class="agpr-topCuratedMentionsField">
        <div class="agpr-topCuratedMentionsField-header">
            <h3>{{ 'Reports.topMentions.topCuratedMentions.header' | localize }}</h3>

            <agpr-button
                class="agpr-topCuratedMentionsField-header-icon"
                [id]="id + '_openDialog'"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-pen"
                [disabled]="mentions.length === maxSelection"
                [tooltip]="mentions.length === maxSelection ? 'Reports.topMentions.topCuratedMentions.header.icon.warning' : 'Reports.topMentions.topCuratedMentions.header.icon.message'"
                tooltipPosition="top"
                (click)="open()"
            ></agpr-button>
        </div>

        <ul
            class="agpr-topCuratedMentionsField-mentionList"
            [dndDropzone]="['mention']"
            dndEffectAllowed="move"
            (dndDrop)="onDrop($event.index)"
        >
            <li
                dndPlaceholderRef
                class="agpr-drag-placeholder"
            ></li>
            @for (mention of mentions; track mention; let index = $index, first = $first, last = $last) {
                <li
                    class="agpr-topCuratedMentionsField-mentionListItem agpr-contextMenu-parent"
                    [dndDraggable]="mention"
                    dndType="mention"
                    dndEffectAllowed="move"
                    (dndStart)="onDragStart(index)"
                >
                    <ul
                        #moveButtons
                        role="menu"
                        class="agpr-contextMenu top left"
                        [attr.aria-label]="'PageBuilder.blockMenu.move' | localize"
                    >
                        <li role="menuitem" class="agpr-contextMenu-menuItem">
                            <agpr-button
                                [id]="id + '_moveUp'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-regular fa-arrow-up"
                                [disabled]="first"
                                tooltip="PageBuilder.briefings.blockIcon.moveUp"
                                tooltipPosition="top"
                                (click)="moveUp(index)"
                            ></agpr-button>
                        </li>
                        <li role="menuitem" class="agpr-contextMenu-menuItem">
                            <agpr-button
                                [id]="id + '_moveDown'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-regular fa-arrow-down"
                                [disabled]="last"
                                tooltip="PageBuilder.briefings.blockIcon.moveDown"
                                tooltipPosition="top"
                                (click)="moveDown(index)"
                            ></agpr-button>
                        </li>
                    </ul>
                    <ul
                        role="menu"
                        class="agpr-contextMenu top right"
                        [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
                    >
                        <li role="menuitem" class="agpr-contextMenu-menuItem">
                            <agpr-button
                                [id]="id + '_delete'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-regular fa-duotone fa-trash-can"
                                tooltip="PageBuilder.briefings.blockIcon.delete"
                                tooltipPosition="top"
                                (click)="delete(index)"
                            ></agpr-button>
                        </li>
                    </ul>
                    <span>{{ mention.headline ? mention.headline : (mention.mediaType.noHeadlineMessage | localize) }}</span>
                </li>
            } @empty {
                <li
                    class="agpr-topCuratedMentionsField-noMentions"
                >
                    <agpr-message
                        [severity]="messageSeverityEnum.noContent"
                    >
                        {{ 'Reports.topMentions.topCuratedMentions.noMentions' | localize }}
                    </agpr-message>
                </li>
            }
        </ul>
    </div>
}
